// Header component - storing heading 
import React from 'react'

class Header extends React.Component {
    render() {
        return(
            <div className="header">
                <h1>Online Quiz</h1>
            </div>
        )
    }
}
export default Header